import {getField, updateField} from 'vuex-map-fields';
import BatchRun from '@/commonFunction/baseTableModule'

let batch_run = new BatchRun('/ws/table/batch_run/');

const state = {
    ...batch_run.state,
    options: {
                page: 1,
                itemsPerPage: 50,
                sortBy: ['title'],
                sortDesc: [false],
                multiSort: false,
                mustSort: true,
                descending: false,

            },
    columns: [
        {text: '', value: 'notion_id', sortable: false, divider: false, width: 30, brief: true,},
        {text: '', value: 'actions', sortable: false, divider: true, width: 30, brief: true,},
        {text: '!', value: 'warning', sortable: false, divider: true, width: 30, brief: true,},
        {text: 'Title', value: 'title', sortable: true, filterable: true, divider: true, brief: true,},
        // {text: 'Year', value: 'batch_run_week_day__year', sortable: true, filterable: true, divider: true, brief: true,},
        // {text: 'Week', value: 'batch_run_week_day__week', sortable: true, filterable: true, divider: true, brief: true,},
        {text: 'Status', value: 'status', sortable: true, divider: true, brief: true,},
        {text: 'Delivery date', value: 'delivery_date', sortable: true, divider: true, brief: false,},
        {text: 'SMD end', value: 'smd_end', sortable: false, filterable: true, divider: true, brief: true,},
        {text: 'SMD days', value: 'smd_init_work_day', sortable: true, filterable: true, divider: true, brief: true,},
        {text: 'THT end', value: 'tht_end', sortable: true, divider: true, brief: true,},
        {text: 'THT days', value: 'tht_init_work_day', sortable: true, divider: true, brief: true,},
        {text: 'SMD + THT', value: 'smd_tht_init_work_day', sortable: true, divider: true, brief: true,},
        // {text: 'LT Plan Mat', value: 'lt_plan_mat', sortable: true, divider: true, brief: true,},
        {text: 'LT Mat', value: 'lt_mat', sortable: true, divider: true, brief: true,},
        {text: 'LT Min', value: 'lt_min', sortable: true, divider: true, brief: true,},
    ],
};
const getters = {
    ...batch_run.getters,
    getColumns(state) {
        if (state.briefView) {
            return state.columns.filter(row => row.brief === true)
        } else {
            return state.columns
        }
    },
};
const actions = {
    ...batch_run.actions,
};
const mutations = {
    ...batch_run.mutations,
};

export default {
    modules: {
        BatchRun: {
            namespaced: true,
            state,
            getters,
            actions,
            mutations
        }
    }
}

// const baseUrl = '/api/quote/'
// const wsURL = '/ws/table/customer/'